import { getHeaders } from './authentication';


type Banner = {
  _id: string;
  url: string;
  title?: string;
  link?: string;
};

interface State {
  banners: Banner[]
  isLoading: boolean;
  error: unknown;
}

const initialState: State = {
  banners: [],
  isLoading: false,
  error: null,
};

const ajaxActionFactory = (verb: string, url: string, method: string, data?: any, callback?) => {
  return ({
    types: [verb, `${verb}_SUCCESS`, `${verb}_FAILURE`],
    payload: {
      request: {
        url,
        method,
        headers: getHeaders(),
        data,
      }
    },
    callback,
  })
};


const _SUCCESS = '_SUCCESS';
const _ERROR = '_FAILURE';
const GET_BANNERS = 'otc/GET_BANNERS';
const POST_BANNER = 'otc/POST_BANNER';
const PUT_BANNER = 'otc/PUT_BANNER';
const DELETE_BANNER = 'otc/DELETE_BANNER';

export const getBanners = () => ajaxActionFactory(
  GET_BANNERS,
  `/otc/banners`,
  'GET',
);

export const addBanner = data => ajaxActionFactory(
  POST_BANNER,
  `/otc/banners`,
  'POST',
  data,
);

export const editBanner = (bannerId, data) => ajaxActionFactory(
  PUT_BANNER,
  `/otc/banners/${bannerId}`,
  'PUT',
  data,
);

export const deleteBanner = bannerId => ajaxActionFactory(
  DELETE_BANNER,
  `/otc/banners/${bannerId}`,
  'DELETE',
  null,
  (err) => console.log('err', err),
);

const otcReducer = (state: State = initialState, action): State => {
  switch (action.type) {
    case `${GET_BANNERS}`:
      return {
        ...state,
        banners: [],
        isLoading: true,
        error: null,
      };
    case `${GET_BANNERS}${_SUCCESS}`:
      return {
        ...state,
        banners: action.payload?.data?.data,
        isLoading: false,
        error: null,
      };
    case `${GET_BANNERS}${_ERROR}`:
    case `${POST_BANNER}${_ERROR}`:
    case `${PUT_BANNER}${_ERROR}`:
    case `${DELETE_BANNER}${_ERROR}`:
      return {
        ...state,
        banners: [],
        isLoading: false,
        error: action?.error?.response?.data?.error?.text || action.error,
      };
    default:
      return state;
  }
}

export default otcReducer;
